import { combineReducers } from 'redux';

import { derivativesSlice } from './slices/derivativesSlice';
import { globalSlice } from './slices/globalSlice';
import { socketSlice } from './slices/socketSlice';
import { spotSlice } from './slices/spotSlice';
import { persistedUserReducer } from './slices/userSlice';

export const rootReducer = combineReducers({
    global: globalSlice.reducer,
    user: persistedUserReducer,
    spot: spotSlice.reducer,
    derivatives: derivativesSlice.reducer,
    socket: socketSlice.reducer,
});
